import { useEffect, useState } from "react"

import { Timer } from "~/types"
import { calculateDurationLeft } from "~/utils/TimerUtils"

export function useCountdown(timer: Timer | null | undefined): number | null {
  const [, setTick] = useState(0)

  // The interval only re-renders; the value is computed below so it always
  // belongs to the timer passed in, even on the render where the timer changes.
  useEffect(() => {
    if (!timer) return

    const interval = setInterval(() => setTick((tick) => tick + 1), 1000)

    return () => clearInterval(interval)
  }, [timer?.id, timer?.started_at, timer?.duration])

  return timer ? calculateDurationLeft(timer) : null
}
